/**
 * @module hooks/useSeriesQuickDragList
 * @description 从 chartData 提取图例系列手动排序种子列表
 */
import { useMemo } from 'react';
import { useQuerySelector, useResultSelector } from './deps';
import { toChartTypeEnum } from '../utils/toChartTypeEnum';
import {
  extractSeriesQuickDragList,
  pickSeriesSourceForQuickDrag,
} from '../settingGroups/LegendSetting/seriesSortUtils';

/**
 * 计算接口返回的系列名列表（手动排序种子，顺序与接口一致）
 */
export function useSeriesQuickDragList(): string[] {
  const chartTypeStr = useQuerySelector(s => s.chartType as string);
  const chartType = useMemo(
    () => toChartTypeEnum(chartTypeStr),
    [chartTypeStr],
  );
  const chartData = useResultSelector(s => s.chartData);
  const chartDataRecord = chartData as Record<string, unknown> | undefined;
  const seriesSource = pickSeriesSourceForQuickDrag(chartType, chartDataRecord);

  return useMemo(
    () => extractSeriesQuickDragList(chartType, chartDataRecord),
    [chartType, chartDataRecord, seriesSource],
  );
}
